export enum TransactionStatus {
  Initialized = 'Initialized',
  Started = 'Started',
  Finished = 'Finished',
  Cancelled = 'Cancelled',
}
